import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { T } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("ftz_lang") || "de";
    }
    return "de";
  });

  useEffect(() => {
    localStorage.setItem("ftz_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((path) => {
    const parts = path.split(".");
    let node = T[lang] || T.de;
    for (const p of parts) {
      node = node?.[p];
      if (node === undefined) {
        // fallback to German
        let fb = T.de;
        for (const q of parts) fb = fb?.[q];
        return fb ?? path;
      }
    }
    return node;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
